
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headstart/[id]/outline",
      function () {
        return require("private-next-pages/headstart/[id]/outline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headstart/[id]/outline"])
      });
    }
  